import { render, staticRenderFns } from "./people_data_table_graduates_advanced_search.vue?vue&type=template&id=0f55a192"
import script from "./people_data_table_graduates_advanced_search.vue?vue&type=script&lang=js"
export * from "./people_data_table_graduates_advanced_search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports